// extracted by mini-css-extract-plugin
export default {"clear":"ClearIndicatorPart_clear__hmBT6","icon":"ClearIndicatorPart_icon__RJ-wB"};